import { useState } from 'react';
import {Container, Row, Col, Modal} from 'react-bootstrap';
import * as Styled from './PublicBetaStyles';
import TrovaLogo from '../../components/TrovaLogo/TrovaLogo';
import closeIcon from '../../../images/close-icon.svg';
import Banner from '../../../images/beta-join.png';
import React from 'react';
import Form from 'react-bootstrap/Form';
import validator from 'validator';
import Api from '../../api/Api';
import HandsCheckmark from '../../../images/Hands-Checkmark.svg';
import UnlockedIcon from '../../../images/hands-unlocked.svg';
import Meta from '../../components/Meta/Meta';
import {H1, H2, HelperText} from '../../styled/Typography';
import {TrovaButton} from '../../styled/Button';

const PublicBeta = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [existingModal, setExistingModal] = useState(false);

  const submitEmail = async (e:any) => {
    e.preventDefault();
    if (validator.isEmail(email)) {
      try {
        const resp = await Api.betaSignup(email);
        const { data } = resp;
        if (data.status === 'in-use') {
          setExistingModal(true);
        } else {
          setShowModal(true);
        }
      } catch (err) {
        setShowModal(true);
        setError('Something went wrong. Please try again later.')
      }
      setEmail('');
    } else {
      setError('Please enter a valid email address');
    }
  }

  const updateEmail = (e:any) => {
    setEmail(e.target.value);
    setError('');
  }

  const closeModal = () => {
    setShowModal(false);
    setExistingModal(false);
    setError('');
  }
  return (
    <Styled.PageWrapper>
      <Meta page="publicbeta" />
      <Styled.NavSection fluid>
        <Styled.StyledLink to='/searchportal' className='NotSignedHeader'>
          <TrovaLogo hasText />
        </Styled.StyledLink>
      </Styled.NavSection>
      <Container fluid="xl">
        <Row>
          <Col md={6} className="d-none d-md-block">
            <Styled.Banner src={Banner} />
          </Col>
          <Col md={6}>
            <Styled.SignUpContainer>
              <Styled.HeaderContainer>
                <H1 color="primary" fontSize="42px">
                  Trova
                </H1>
                <H2 color="primary" fontSize="30px">
                  Public Beta
                </H2>
              </Styled.HeaderContainer>
              <Styled.CopyText>
                Personal unified search service across different platforms to find your scattered information quickly.
              </Styled.CopyText>
              <Form inline style={{ flex: 1 }} onSubmit={submitEmail} >
                <Styled.StyledFormControl
                  type="text"
                  placeholder="Your email"
                  value={email}
                  onChange={updateEmail}
                />
                <Styled.Btn type="submit">
                  Join
                </Styled.Btn>
              </Form>
              <HelperText color="analogousPurple" align="left" mt={2}>
                * We currently only support sign in with Google or Microsoft
              </HelperText>
              {error &&
                <Styled.ErrorText>
                  {error}
                </Styled.ErrorText>
              }
              <Styled.BtnContainer>
                <TrovaButton href="/signin" className="SignInBtn">
                  Already invited? Sign in
                </TrovaButton>
              </Styled.BtnContainer>
            </Styled.SignUpContainer>
          </Col>
        </Row>
      </Container>
      <Modal
        show={showModal}
        onHide={closeModal}
        animation={false}
        centered
        size='sm'
        contentClassName='custom-content'
        dialogClassName='custom-dialog'
      >
        <Styled.ModalBody>
          {!error ?
            <>
              <Styled.InviteParagraph>
                <img src={HandsCheckmark} alt="all good" />
                <p>
                  We’ve got your request.
                  You will receive a confirmation email within 24 hours.
                </p>
              </Styled.InviteParagraph>
              <Styled.StyledModalBtn variant='secondary' onClick={closeModal} >
                Got It
              </Styled.StyledModalBtn>
            </>
            :
            <Styled.InviteParagraph>
              {error}
              <Styled.StyledModalBtn variant='secondary' onClick={closeModal} >
                Got It
              </Styled.StyledModalBtn>
            </Styled.InviteParagraph>
          }
          <Styled.CloseButton
            onClick={closeModal}
            variant='link'
          >
            <img src={closeIcon} alt='' />
          </Styled.CloseButton>
        </Styled.ModalBody>
      </Modal>
      <Modal
        show={existingModal}
        onHide={closeModal}
        animation={false}
        centered
        size='sm'
        contentClassName='custom-content'
        dialogClassName='custom-dialog'
      >
        <Styled.ModalBody>
          <Styled.InviteParagraph>
            <img src={UnlockedIcon} alt="all good" />
            <p>
              Congratulations! It looks like you already have a Trova account!
              Just sign in!
            </p>
          </Styled.InviteParagraph>
          <Styled.StyledModalBtn variant='secondary' onClick={closeModal} >
            Got It
          </Styled.StyledModalBtn>
        </Styled.ModalBody>
        <Styled.CloseButton
          onClick={closeModal}
          variant='link'
        >
          <img src={closeIcon} alt='' />
        </Styled.CloseButton>
      </Modal>
    </Styled.PageWrapper>
  )
}

export default PublicBeta